import template from './infinite-trigger.template.html';
import './infinite-trigger.scss';

export default {
  template,
  bindings: {
    onVisible: '&',
  },
};



// WEBPACK FOOTER //
// ./src/app/shared/infinite-trigger/infinite-trigger.component.js